import { useEffect, useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { recruitingApi } from '../../../api/recruiting.js';

export default function RequisitionDetail() {
  const { id } = useParams();
  const [req, setReq] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setLoading(true);
    recruitingApi
      .getRequisition(id)
      .then((d) => setReq(d?.requisition || null))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(refresh, [refresh]);

  async function submitForApproval() {
    try {
      await recruitingApi.submitRequisition(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit');
    }
  }

  if (loading && !req) return <div className="muted" data-testid="recruiting-requisition-detail-page" data-loading="true">Loading…</div>;
  if (!req) return <div className="alert error">Requisition not found</div>;

  return (
    <section data-testid="recruiting-requisition-detail-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>{req.title}</h1>
          <p className="muted">{req.department_name || 'No department'} · {req.headcount} headcount</p>
        </div>
        <div className="actions">
          <Link to={`/recruiting/requisitions/${id}/pipeline`} className="btn ghost" data-testid="recruiting-requisition-pipeline-link">Pipeline</Link>
          {req.status === 'draft' && (
            <button className="btn primary" data-testid="recruiting-requisition-submit-approval" onClick={submitForApproval}>
              Submit for approval
            </button>
          )}
        </div>
      </header>

      {error && <div className="alert error">{error}</div>}

      <div className="card">
        <dl className="kv">
          <dt>Status</dt><dd><span className={`chip status-${req.status}`} data-testid="recruiting-requisition-detail-status">{req.status}</span></dd>
          <dt>Employment Type</dt><dd>{req.employment_type || '—'}</dd>
          <dt>Location</dt><dd>{req.location || '—'}</dd>
          <dt>Hiring Manager</dt><dd>{req.hiring_manager_name || '—'}</dd>
          <dt>Justification</dt><dd>{req.justification || '—'}</dd>
        </dl>
      </div>
    </section>
  );
}
